module.exports = __webpack_public_path__ + "img/icon4.90ed2efa.svg";